import { connect } from 'react-redux';
import Transfer from './Transfer';
import { RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  name: state.investments.legal_name || state.investments.name,
});

export default connect(mapStateToProps)(Transfer);
